import { useOrganizationStore } from '@shared/hooks/state/OrganizationContainer';
import { useEffect, useMemo } from 'react';
import useResolveCurrentOrg from './useResolveCurrentOrg';

export function useCurrentOrgMemberFetching() {
    const { organizationId } = useResolveCurrentOrg();
    const organizationMembers = useOrganizationStore((state) => state.organizationMembers);
    const isLoading = useOrganizationStore((state) => state.loadingData.organizationMembers);

    const members = useMemo(() => {
        if (!organizationId) return null;
        return organizationMembers.find((org) => org.organizationId === organizationId)?.members ?? [];
    }, [organizationId, organizationMembers]);

    useEffect(() => {
        async function fetchMembers() {
            if (!organizationId || useOrganizationStore.getState().loadingData.organizationMembers == true) return;
            useOrganizationStore.getState().handleLoadingDataChange('organizationMembers', true);
            const org = useOrganizationStore
                .getState()
                .organizationMembers.find((org) => org.organizationId === organizationId);
            if (org?.members && org.members.length > 0) {
                useOrganizationStore.getState().handleLoadingDataChange('organizationMembers', false);
                return;
            }

            try {
                const result = await useOrganizationStore.getState().loadOrganizationMembers(organizationId);
                if (result?.resultType !== 'Ok') {
                    console.error('Failed to load members for organization:', organizationId);
                }
            } catch (error) {
                console.error('Error loading members.');
            } finally {
                useOrganizationStore.getState().handleLoadingDataChange('organizationMembers', false);
            }
        }
        fetchMembers();
    }, [organizationId]);

    return { members, isLoading };
}
